module.exports = __webpack_public_path__ + "static/media/nusLogo2.381833ba.jpg";